export default "/images/a5a1175d1a7497d2569537e05a9de36a.avif";